import MuiDialogActions, { DialogActionsProps as MuiDialogActionsProps } from '@mui/material/DialogActions';
import * as React from 'react';

export interface DialogActionsProps extends MuiDialogActionsProps {}

export const DialogActions = (props: DialogActionsProps) => {
  return <MuiDialogActions {...props} />;
};
